
import { z } from "zod";

export const RoofMaterialValues = ["ASPHALT", "TILE"] as const;
export const RoofMaterialSchema = z.enum(RoofMaterialValues);
export const RoofMaterial = RoofMaterialSchema.enum;
export type RoofMaterial = (typeof RoofMaterialValues)[number];
